@if (visible()) {
  <div class="modal-backdrop" (click)="onCancel()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <span class="material-symbols-outlined warning-icon">warning</span>
        <h2 class="modal-title">Unsaved Changes</h2>
        <button type="button" class="modal-close" (click)="onCancel()" aria-label="Close">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="modal-content">
        <p class="modal-message">{{ message() }}</p>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="modal-button dont-save-button"
          (click)="onDontSave()">
          Don't Save
        </button>
        <button
          type="button"
          class="modal-button cancel-button"
          (click)="onCancel()">
          Cancel
        </button>
        <button
          type="button"
          class="modal-button save-button"
          (click)="onSave()">
          Save
        </button>
      </div>
    </div>
  </div>
}
